<template>
  <div style="margin-top: 20px">
    <el-row>
      <el-col :span="24">
        <el-card class="box-card" style="width: 750px; margin: 0px auto;">
          <div slot="header" style="margin-bottom: 10px">
          </div>
          <div>
            <el-tabs style="padding-top: 10px" v-model="tabs" @tab-click="tabClick">
              <el-tab-pane label="报价器" name="menu">
                <el-card class="box-card">
                  <div slot="header" class="clearfix">
                    <span>报价器设置</span>
                    <el-button style="float: right; padding: 3px 0" type="text" @click="setDefaultMenu">初始化</el-button>
                  </div>
                  <el-alert
                    title="提示:排序的值需大于100"
                    type="success">
                  </el-alert>
                  <el-table
                    :data="menus"
                    style="width: 100%" size="mini">
                    <el-table-column
                      prop="name"
                      label="报价器"
                      header-align="center"
                      align="center"
                    >
                    </el-table-column>
                    <el-table-column
                      label="排序"
                      header-align="center"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.level" @blur="onMenuChange"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="操作"
                      header-align="center"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <el-switch
                          v-model="scope.row.isCheck"
                          active-text="开启"
                          inactive-text="关闭"
                          @change="onMenuChange(scope.row)">
                        </el-switch>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-card>
              </el-tab-pane>
              <el-tab-pane label="小信鸽" name="default" v-if="false">
                <el-card class="box-card">
                  <div slot="header" class="clearfix">
                    <span>小信鸽设置</span>
                  </div>
                  <el-form ref="form" :model="form" label-width="120px">
                    <el-form-item label="保留最近">
                      <el-input-number v-model="num" @change="handleChange" :min="0" label="请输入天数"></el-input-number>
                      天消息
                    </el-form-item>
                    <el-form-item label="提示音">
                      <el-switch
                        v-model="warningTone"
                        active-text="开启"
                        inactive-text="关闭" @change="setWarningTone">
                      </el-switch>
                    </el-form-item>
                    <el-form-item label="平台消息提醒">
                      <el-switch
                        v-model="platformMsgWarn"
                        active-text="开启"
                        inactive-text="关闭" @change="setPlatformMsgWarn">
                      </el-switch>
                    </el-form-item>
                    <el-form-item label="客服消息提醒">
                      <el-switch
                        v-model="serviceMsgWarn"
                        active-text="开启"
                        inactive-text="关闭" @change="setServiceMsgWarn">
                      </el-switch>
                    </el-form-item>
                    <el-form-item label="">
                      <el-button type="text" @click="onRemoveDate">清空本地消息</el-button>
                    </el-form-item>
                  </el-form>
                </el-card>
              </el-tab-pane>
              <el-tab-pane  label="快捷键设置" name="shortcutKey">
                <el-table
                  :data="keys"
                  style="width: 100%" size="mini">
                  <el-table-column
                    prop="name"
                    label="按钮名称"
                    header-align="center"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="keyName"
                    label="快捷键"
                    header-align="center"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column>
                    <template slot-scope="scope">
                      <el-link type="primary" @click="showSetKey(scope.row)">设置</el-link>
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-dialog
      title="快捷键设置"
      :visible.sync="dialogVisible" :close-on-press-escape="false"
      width="30%" @close="closeKeySet">
      <p>请按下您要设置的快捷键</p>
      <el-form>
        <el-form-item :label="key.name">
          {{key.keyName}}
          <el-link type="primary" v-if="key.keyName.length>0" @click="resetKeyCode">重置</el-link>
        </el-form-item>
        <el-form-item>
          <el-button @click="addKeySet">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import { initData } from '../api/MsgApi'
  import localforage from 'localforage'
  import hotkeys from "hotkeys-js";
  import { log } from '../api/log'
  export default {
    name: 'Set',
    data () {
      return {
        form: {},
        num: 10,
        removeDate: '',
        user: {},
        warningTone: true,
        platformMsgWarn: true,
        serviceMsgWarn: true,
        tabs: 'menu',
        menus: [],
        selectMenus: [],
        keys:[],
        dialogVisible:false,
        key:{
           id:0,
          code:'',
          name:'',
          keyName:'',
          keyCode:''
        },
      }
    },
    created () {
      this.user = this.$store.getters['user']
      this.getNum()
      this.getWarningTone()
      this.platformMsgWarn = this.$store.getters.platformMsgWarn
      this.serviceMsgWarn = this.$store.getters.serviceMsgWarn
      this.getMenu()
      this.getHortcutsKey()
    },
    filters:{
      filtersKeyName(val){
        let s=val.split('^')
        let name=''
        s.forEach((item,index)=>{
          console.log(item)
          switch (item) {
            case '-1':
              name+='未设置'+'+'
              break
            case '13':
              name+='回车'+'+'
              break
            case '32':
              name+='空格'+'+'
              break
            default :
              name+= String.fromCharCode(item)+'+'
              break
          }
        })
        name=name.substring(0,name.length-1)
        return name
      }
    },
    mounted() {

    },
    beforeDestroy() {
      hotkeys.unbind("*");
    },
    methods: {
      //消息保留天数
      getNum () {
        let localNum = localStorage.getItem(this.user.accountNo + '_setNum')
        if (localNum == undefined) {
          localStorage.setItem(this.user.accountNo + '_setNum', 10)
        } else {
          this.num = localNum
        }
      },
      //获取提示音
      getWarningTone () {
        let _warningTone = localStorage.getItem(this.user.accountNo + '_warningTone')
        if (_warningTone == undefined) {
          _warningTone = true
          localStorage.setItem(this.user.accountNo + '_warningTone', _warningTone)
        }
        this.warningTone = (_warningTone == 'true' ? true : false)
      },
      //提示音保存到本地数据库
      setWarningTone (value) {
        localStorage.setItem(this.user.accountNo + '_warningTone', value)
        this.$store.commit('SET_IS_PLAYING', value)
      },
      //系统提醒保留到本地数据库
      setServiceMsgWarn (value) {
        localStorage.setItem(this.user.accountNo + '_serviceMsgWarn', value)
        this.$store.commit('SET_SERVICE_MSG_WARN', value)
      },
      //客服提醒保留到本地数据库
      setPlatformMsgWarn (value) {
        localStorage.setItem(this.user.accountNo + '_platformMsgWarn', value)
        this.$store.commit('SET_PLATFORM_MSG_WARN', value)
      },
      //本地消息天数保留到本地数据库
      handleChange (value) {
        localStorage.setItem(this.user.accountNo + '_setNum', value)
      },
      //清空本地消息
      onRemoveDate () {
        let that = this
        this.$confirm('此操作将永久删除本地聊天记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.removeDB()
          that.$message({
            type: 'success',
            showClose: true,
            message: '删除成功!'
          })
        }).catch(() => {
          that.$message({
            type: 'info',
            showClose: true,
            message: '已取消删除'
          })
        })
      },
      removeDB () {
        let that = this
        let date = new Date()
        let num = this.num
        this.removeDate = date.setTime(date.valueOf() - (num * 24 * 60 * 60 * 1000))
        let db = this.$store.getters.webDB
        db.iterate(function (value1, key, iterationNumber) {
          // 此回调函数将对所有 key/value 键值对运行
        }).then(function () {
          console.log('Iteration has completed')
        }).catch(function (err) {
          // 当出错时，此处代码运行
          console.log(err)
        })

      },

      getMenu () {
        let menu = localStorage.getItem('menu_' + this.user.accountNo)
        if (menu != null) {
          this.menus = JSON.parse(menu)
          this.menus = this._.orderBy(this.menus, ['level'], ['asc'])
        } else {
          this.menus = that.$store.getters['defaultMenu']
          this.menus = this._.orderBy(this.menus, ['level'], ['asc'])
        }
      },
      tabClick (tab, event) {
        if (tab.name == 'menu') {
          this.getMenu()
        }
      },
      onMenuChange (row) {
        let that = this
        //读取默认的menu列表
        let menuList = this.menus
        //更新到数据库中
        localStorage.setItem('menu_' + this.user.accountNo, JSON.stringify(menuList))
        let defaultPriceUrls = menuList.filter(item => {
          if (item.isCheck) {
            return item
          }
        })
        //修改默认的报价器url
        localStorage.setItem('DEFAULT_PRICE_URL', defaultPriceUrls[0].path)
        this.getMenu()
      },
      //初始化按钮
      setDefaultMenu () {
        let menu = this.$store.getters['defaultMenu']
        let version = this.$store.state.menuVersion
        localStorage.setItem('menu_' + this.user.accountNo, JSON.stringify(menu))
        localStorage.setItem('menuVersion_' + this.accountNo, version)
        this.$message({
          type: 'success',
          showClose: true,
          message: '初始化成功!'
        })
        this.getMenu()
      },
      //获取快捷键
      getHortcutsKey(){
        let that=this
        localforage.getItem('key_' + this.user.accountNo).then(keys=>{
          if (keys != null) {
            this.keys = JSON.parse(keys)
          } else {
            this.keys = that.$store.getters['keys']
            localforage.setItem('key_'+this.user.accountNo,JSON.stringify(this.keys))
          }
        })
      },
      addKeySet(){
        let that=this
        this.key.keyCode=this.key.keyCode.substring(0,this.key.keyCode.length-1)
        console.log(this.key)
       let m= this.keys.map(item=>{
          if(item.id==that.key.id){
            item=that.key
            return item
          }
          return  item
        })
        this.keys=m
        localforage.setItem('key_'+this.user.accountNo,JSON.stringify(m))
        this.closeKeySet()
      },
      showSetKey(row){
        this.dialogVisible=true
        this.key.id=row.id
        this.key.name=row.name
        this.key.keyName=row.keyName
        this.key.keyCode=row.keyCode
        this.key.code=row.code
        hotkeys("*", (e) =>{
          let keyText=e.key
         let keyCode= e.key.toLocaleLowerCase()
          if(e.keyCode==32){
            keyText='空格'
            keyCode='space'
          }
          this.key.keyName+=keyText
          this.key.keyCode+=keyCode+'+'
        } );
      },
      resetKeyCode(){
        this.key.keyName=''
        this.key.keyCode=''
      },
      closeKeySet(){
        this.key={
          id:0,
          code:'',
          name:'',
          keyName:'',
          keyCode:''
        }
        this.dialogVisible=false
        hotkeys.unbind("*");
      }
    }
  }
</script>

<style scoped>
  /deep/ .el-card__body {
    padding-top: 10px;
  }
</style>
